<template>
  <el-drawer
    :append-to-body="true"
    :title="$t('seller.informationDetails')"
    :visible.sync="infoDetailDialog"
    custom-class="drawerClass"
    direction="ltr"
    size="950px"
    @close="handleNewCodeDialog"
  >
    <div style="padding: 0 20px; overflow-y: auto; height: calc(100vh - 100px)">
      <div class="titleLabel">{{ $t('seller.invitationCodeInfo') }}</div>
      <el-descriptions :colon="false" :column="4" direction="vertical">
        <!-- 网点名称 -->
        <el-descriptions-item :label="$t('navbar.siteName')">
          <div>{{ rowObj.siteName || '--' }}</div>
        </el-descriptions-item>
        <!--账号名称-->
        <el-descriptions-item :label="$t('customerManagements.AccountName')">
          <div>{{ rowObj.userName || '--' }}</div>
        </el-descriptions-item>
        <!--派送车辆类型-->
        <el-descriptions-item :label="$t('receivablePayable.deliveryVehicleType')">
          <div>{{ rowObj.deliveryVehicleType || '--' }}</div>
        </el-descriptions-item>
        <!-- 派送价格 -->
        <el-descriptions-item :label="$t('seller.deliveryPrice')">
          <div>{{ rowObj.deliveryPrice || '--' }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="titleLabel">{{ $t('seller.identityInfo') }}</div>
      <el-descriptions :colon="false" :column="4" direction="vertical">
        <!-- 司机名称 -->
        <el-descriptions-item :label="$t('collectionCenter.theDriverName')">
          <div>{{ identityInfo.realName || '--' }}</div>
        </el-descriptions-item>
        <!--CNPJ号码-->
        <el-descriptions-item :label="$t('seller.cnpjNumber')">
          <div>{{ identityInfo.cnpjNumber || '--' }}</div>
        </el-descriptions-item>
        <!-- CPF号码-->
        <el-descriptions-item :label="$t('seller.CPFNumber')">
          <div>{{ identityInfo.cpfNumber || '--' }}</div>
        </el-descriptions-item>
        <!--ANTT-RNTRC-->
        <el-descriptions-item label="ANTT-RNTRC">
          <div>{{ identityInfo.anttRntrc || '--' }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="titleLabel">{{ $t('seller.fileImages') }}</div>
      <el-descriptions :colon="false" :column="3" direction="vertical">
        <!-- Documentos e Licenças -->
        <el-descriptions-item label="Documentos e Licenças">
          <div
            v-if="fileUpload.documentsAndLicenses"
            class="demo-image__preview"
            style="z-index: 9999"
          >
            <el-image
              v-for="(item2, index2) in fileUpload.documentsAndLicensesList"
              :key="index2"
              :preview-src-list="[item2]"
              :src="item2"
              fit="contain"
              style="width: 100px; margin-right: 5px"
            />
          </div>
          <div v-else>--</div>
        </el-descriptions-item>
        <el-descriptions-item label="Comprovante de propriedade do veículo">
          <div
            v-if="fileUpload.proofOfVehicleOwnership"
            class="demo-image__preview"
            style="z-index: 9999"
          >
            <el-image
              v-for="(item2, index2) in fileUpload.shipList"
              :key="index2"
              :preview-src-list="[item2]"
              :src="item2"
              fit="contain"
              style="width: 100px; margin-right: 5px"
            />
          </div>
          <div v-else>--</div>
        </el-descriptions-item>
        <el-descriptions-item label="CNH">
          <div v-if="fileUpload.cnh" class="demo-image__preview" style="z-index: 9999">
            <el-image
              v-for="(item2, index2) in fileUpload.cnhList"
              :key="index2"
              :preview-src-list="[item2]"
              :src="item2"
              fit="contain"
              style="width: 100px; margin-right: 5px"
            />
          </div>
          <div v-else>--</div>
        </el-descriptions-item>
        <el-descriptions-item label="CRLV">
          <div v-if="fileUpload.crlv" class="demo-image__preview" style="z-index: 9999">
            <el-image
              v-for="(item2, index2) in fileUpload.crlvList"
              :key="index2"
              :preview-src-list="[item2]"
              :src="item2"
              fit="contain"
              style="width: 100px; margin-right: 5px"
            />
          </div>
          <div v-else>--</div>
        </el-descriptions-item>
        <el-descriptions-item label="Comprovante de residência válido nos últimos 90 dias">
          <div
            v-if="fileUpload.proofOfResidenceValidWithin90Days"
            class="demo-image__preview"
            style="z-index: 9999"
          >
            <el-image
              v-for="(item2, index2) in fileUpload.Days90List"
              :key="index2"
              :preview-src-list="[item2]"
              :src="item2"
              fit="contain"
              style="width: 100px; margin-right: 5px"
            />
          </div>
          <div v-else>--</div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="titleLabel">{{ $t('GlobalSetObj.Bankinformation') }}</div>
      <el-descriptions :colon="false" :column="4" direction="vertical">
        <!-- 银行名称 -->
        <el-descriptions-item :label="$t('seller.bankName')">
          <div>{{ bankInfo.bank || '--' }}</div>
        </el-descriptions-item>
        <!--代理-->
        <el-descriptions-item :label="$t('seller.agent')">
          <div>{{ bankInfo.agent || '--' }}</div>
        </el-descriptions-item>
        <!--银行账号-->
        <el-descriptions-item :label="$t('GlobalSetObj.bankAccount')">
          <div>{{ bankInfo.bankCardNumber || '--' }}</div>
        </el-descriptions-item>
        <!-- PIX -->
        <el-descriptions-item label="PIX">
          <div>{{ bankInfo.pix || '--' }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="titleLabel">{{ $t('seller.driverInfo') }}</div>
      <el-descriptions :colon="false" :column="4" direction="vertical">
        <!-- 邮编 -->
        <el-descriptions-item :label="$t('orderDetails.zipcode')">
          <div>{{ driverInfo.driverZipCode || '--' }}</div>
        </el-descriptions-item>
        <!-- 街道 -->
        <el-descriptions-item :label="$t('driver.modalStreet')">
          <div>{{ driverInfo.driverStreet || '--' }}</div>
        </el-descriptions-item>
        <!-- 区/邻里 -->
        <el-descriptions-item :label="$t('seller.districtNeighborhood')">
          <div>{{ driverInfo.driverNeighborhood || '--' }}</div>
        </el-descriptions-item>
        <!-- 楼栋号 -->
        <el-descriptions-item :label="$t('seller.buildingNumber')">
          <div>{{ driverInfo.driverBuildingNumber || '--' }}</div>
        </el-descriptions-item>
        <!-- 补充  -->
        <el-descriptions-item :label="$t('placeOrder.Complement')">
          <div>{{ driverInfo.driverSupplement || '--' }}</div>
        </el-descriptions-item>
        <!-- 城市  -->
        <el-descriptions-item :label="$t('orderDetails.City')">
          <div>{{ driverInfo.driverCity || '--' }}</div>
        </el-descriptions-item>
        <!-- 州  -->
        <el-descriptions-item :label="$t('placeOrder.State')">
          <div>{{ driverInfo.driverState || '--' }}</div>
        </el-descriptions-item>
        <!-- 司机全名 -->
        <el-descriptions-item :label="$t('seller.driverFullName')">
          <div>{{ driverInfo.driverFullName || '--' }}</div>
        </el-descriptions-item>
        <!-- RG号码 -->
        <el-descriptions-item :label="$t('seller.rgNumber')">
          <div>{{ driverInfo.driverRGNumber || '--' }}</div>
        </el-descriptions-item>
        <!-- 身份颁发州 -->
        <el-descriptions-item :label="$t('seller.idIssuingState')">
          <div>{{ driverInfo.driverIdentityState || '--' }}</div>
        </el-descriptions-item>
        <!-- 出生日期 -->
        <el-descriptions-item :label="$t('seller.dateOfBirth')">
          <div>{{ driverInfo.driverBirthDate || '--' }}</div>
        </el-descriptions-item>
        <!-- PIS -->
        <el-descriptions-item label="PIS">
          <div>{{ driverInfo.driverPis || '--' }}</div>
        </el-descriptions-item>
        <!-- 父亲姓名 -->
        <el-descriptions-item :label="$t('seller.fatherName')">
          <div>{{ driverInfo.driverFatherName || '--' }}</div>
        </el-descriptions-item>
        <!-- 母亲姓名 -->
        <el-descriptions-item :label="$t('seller.motherName')">
          <div>{{ driverInfo.driverMotherName || '--' }}</div>
        </el-descriptions-item>
        <!-- 司机手机手机号码 -->
        <el-descriptions-item :label="$t('collectionCenter.phoneNumber')">
          <div>{{ driverInfo.driverMobileNumber || '--' }}</div>
        </el-descriptions-item>
        <!-- 电话号码 -->
        <el-descriptions-item :label="$t('orderCenterCont.telephoneNumber')">
          <div>{{ driverInfo.driverPhoneNumber || '--' }}</div>
        </el-descriptions-item>
        <!-- 邮箱 -->
        <el-descriptions-item :label="$t('orderDetails.email')">
          <div>{{ driverInfo.email || '--' }}</div>
        </el-descriptions-item>
        <!-- 婚姻状况 -->
        <el-descriptions-item :label="$t('seller.maritalStatus')">
          <div>{{ driverInfo.driverMaritalStatus || '--' }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="titleLabel">{{ $t('seller.documentInfo') }}</div>
      <el-descriptions :colon="false" :column="4" direction="vertical">
        <!-- 驾驶证号码 -->
        <el-descriptions-item :label="$t('seller.driverLicenseNumber')">
          <div>{{ documentsInfo.driverCertificateNumber || '--' }}</div>
        </el-descriptions-item>
        <!--证件首次颁发日期-->
        <el-descriptions-item :label="$t('seller.licenseFirstIssueDate')">
          <div>{{ documentsInfo.certificateFirstDate || '--' }}</div>
        </el-descriptions-item>
        <!--到期日期-->
        <el-descriptions-item :label="$t('seller.expiryDate')">
          <div>{{ documentsInfo.certificateExpireDate || '--' }}</div>
        </el-descriptions-item>
        <!-- 驾驶证颁发州 -->
        <el-descriptions-item :label="$t('seller.licenseIssuingState')">
          <div>{{ documentsInfo.driverCertificateState || '--' }}</div>
        </el-descriptions-item>
        <!--驾驶证类型-->
        <el-descriptions-item :label="$t('seller.licenseType')">
          <div>{{ documentsInfo.driverCertificateType || '--' }}</div>
        </el-descriptions-item>
        <!--安全码-->
        <el-descriptions-item :label="$t('seller.securityCode')">
          <div>{{ documentsInfo.safetyCode || '--' }}</div>
        </el-descriptions-item>
        <!--Renach Licences-->
        <el-descriptions-item label="Renach Licences">
          <div>{{ documentsInfo.renachLicences || '--' }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="titleLabel">{{ $t('seller.vehicleInfo') }}</div>
      <el-descriptions :colon="false" :column="4" direction="vertical">
        <!-- 车辆类型 -->
        <el-descriptions-item :label="$t('collectionCenter.carType')">
          <div>{{ vehicleInfo.vehicleType || '--' }}</div>
        </el-descriptions-item>
        <!--车牌号-->
        <el-descriptions-item :label="$t('seller.licensePlateNumber')">
          <div>{{ vehicleInfo.vehicleNumber || '--' }}</div>
        </el-descriptions-item>
        <!--车架号-->
        <el-descriptions-item :label="$t('seller.vinNumber')">
          <div>{{ vehicleInfo.vin || '--' }}</div>
        </el-descriptions-item>
        <!-- 车身 -->
        <el-descriptions-item :label="$t('seller.vehicleBody')">
          <div>{{ vehicleInfo.bodyworks || '--' }}</div>
        </el-descriptions-item>
        <!-- 车辆品牌 -->
        <el-descriptions-item :label="$t('Resource.vehicleBrand')">
          <div>{{ vehicleInfo.vehicleBrand || '--' }}</div>
        </el-descriptions-item>
        <!--车辆制造年份-->
        <el-descriptions-item :label="$t('seller.vehicleManufactureYear')">
          <div>{{ vehicleInfo.vehicleCreateYear || '--' }}</div>
        </el-descriptions-item>
        <!--车辆型号年份-->
        <el-descriptions-item :label="$t('seller.vehicleModelYear')">
          <div>{{ vehicleInfo.vehicleModelYear || '--' }}</div>
        </el-descriptions-item>
        <!--车辆型号-->
        <el-descriptions-item :label="$t('Resource.vehicleModel')">
          <div>{{ vehicleInfo.vehicleModel || '--' }}</div>
        </el-descriptions-item>
        <!--车辆颜色-->
        <el-descriptions-item :label="$t('seller.vehicleColor')">
          <div>{{ vehicleInfo.vehicleColour || '--' }}</div>
        </el-descriptions-item>
        <!--车辆登记号-->
        <el-descriptions-item :label="$t('seller.vehicleRegistrationNumber')">
          <div>{{ vehicleInfo.vehicleRegistrationNumber || '--' }}</div>
        </el-descriptions-item>
        <!--  车牌登记城市  -->
        <el-descriptions-item :label="$t('seller.licensePlateRegistrationCity')">
          <div>{{ vehicleInfo.vehicleNumberCity || '--' }}</div>
        </el-descriptions-item>
        <!--车牌所属州-->
        <el-descriptions-item :label="$t('seller.licensePlateState')">
          <div>{{ vehicleInfo.vehicleNumberState || '--' }}</div>
        </el-descriptions-item>
        <!--车辆拥有者-->
        <el-descriptions-item :label="$t('seller.vehicleOwner')">
          <div>{{ vehicleInfo.vehicleOwnerName || '--' }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <div v-if="vehicleOwnerInfo" class="titleLabel">{{ $t('seller.ownerInfo') }}</div>
      <el-descriptions
        v-if="vehicleOwnerInfo" :colon="false" :column="4"
        direction="vertical"
      >
        <!-- 车主全名 -->
        <el-descriptions-item :label="$t('seller.ownerFullName')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerFullName || '--' }}</div>
        </el-descriptions-item>
        <!--车主CPF-->
        <el-descriptions-item :label="$t('seller.ownerCpf')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerCpf || '--' }}</div>
        </el-descriptions-item>
        <!-- RG -->
        <el-descriptions-item label="RG">
          <div>{{ vehicleOwnerInfo.vehicleOwnerRgNumber || '--' }}</div>
        </el-descriptions-item>
        <!--车主身份证颁发州-->
        <el-descriptions-item :label="$t('seller.ownerIdIssueState')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerIDState || '--' }}</div>
        </el-descriptions-item>
        <!--车主父亲全名-->
        <el-descriptions-item :label="$t('seller.ownerFatherFullName')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerFatherFullName || '--' }}</div>
        </el-descriptions-item>
        <!--车主母亲全名-->
        <el-descriptions-item :label="$t('seller.ownerMotherFullName')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerMotherFullName || '--' }}</div>
        </el-descriptions-item>
        <!-- 手机号码 -->
        <el-descriptions-item :label="$t('collectionCenter.phoneNumber')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerPhoneNumber || '--' }}</div>
        </el-descriptions-item>
        <!-- 邮编 -->
        <el-descriptions-item :label="$t('newOrder.ZipCode')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerZipCode || '--' }}</div>
        </el-descriptions-item>
        <!-- 地址 -->
        <el-descriptions-item :label="$t('base.address')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerAddress || '--' }}</div>
        </el-descriptions-item>
        <!-- 门牌号 -->
        <el-descriptions-item :label="$t('placeOrder.HouseNumber')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerHouseNumber || '--' }}</div>
        </el-descriptions-item>
        <!-- 区/邻里 -->
        <el-descriptions-item :label="$t('seller.districtNeighborhood')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerNeighborhood || '--' }}</div>
        </el-descriptions-item>
        <!-- 补充 -->
        <el-descriptions-item :label="$t('placeOrder.Complement')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerSupplement || '--' }}</div>
        </el-descriptions-item>
        <!-- 城市 -->
        <el-descriptions-item :label="$t('orderDetails.City')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerCity || '--' }}</div>
        </el-descriptions-item>
        <!-- 州 -->
        <el-descriptions-item :label="$t('placeOrder.State')">
          <div>{{ vehicleOwnerInfo.vehicleOwnerState || '--' }}</div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
export default {
  data() {
    return {
      infoDetailDialog: false,
      rowObj: {},
      bankInfo: {},
      driverInfo: {},
      addressInfo: {},
      vehicleInfo: {},
      vehicleOwnerInfo: {},
      documentsInfo: {},
      identityInfo: {},
      fileUpload: {}
    };
  },
  methods: {
    // 控制弹框
    openDetailDialog(row) {
      this.rowObj = row;
      console.log(this.rowObj, 'rowObj');
      if (this.rowObj.submitInfo) {
        this.bankInfo = this.rowObj.submitInfo.bankInfo;
        this.driverInfo = this.rowObj.submitInfo.driverInfo;
        this.addressInfo = this.rowObj.submitInfo.addressInfo;
        this.vehicleInfo = this.rowObj.submitInfo.vehicleInfo;
        if (this.vehicleInfo.vehicleOwner) {
          if (this.vehicleInfo.vehicleOwner === 1) {
            this.vehicleInfo.vehicleOwnerName = this.$t('GlobalSetObj.Myself');
          } else {
            this.vehicleInfo.vehicleOwnerName = this.$t('GlobalSetObj.NotMyself');
          }
        }
        this.vehicleOwnerInfo = this.rowObj.submitInfo.vehicleOwnerInfo;
        this.documentsInfo = this.rowObj.submitInfo.documentsInfo;
        this.identityInfo = this.rowObj.submitInfo.identityInfo;
        this.fileUpload = this.rowObj.submitInfo.fileUpload;
        if (this.fileUpload.cnh) {
          this.fileUpload.cnhList = this.fileUpload.cnh.split(',');
        } else {
          this.fileUpload.cnhList = [];
        }
        if (this.fileUpload.crlv) {
          this.fileUpload.crlvList = this.fileUpload.crlv.split(',');
        } else {
          this.fileUpload.crlvList = [];
        }
        if (this.fileUpload.documentsAndLicenses) {
          this.fileUpload.documentsAndLicensesList = this.fileUpload.documentsAndLicenses.split(',');
        } else {
          this.fileUpload.documentsAndLicensesList = [];
        }
        if (this.fileUpload.proofOfVehicleOwnership) {
          this.fileUpload.shipList = this.fileUpload.proofOfVehicleOwnership.split(',');
        } else {
          this.fileUpload.shipList = [];
        }
        if (this.fileUpload.proofOfResidenceValidWithin90Days) {
          this.fileUpload.Days90List = this.fileUpload.proofOfResidenceValidWithin90Days.split(',');
        } else {
          this.fileUpload.Days90List = [];
        }
      }
      this.infoDetailDialog = true;
    },
    handleNewCodeDialog() {
      this.infoDetailDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.titleLabel {
  font-size: 16px;
  color: #00A551;
  font-weight: 600;
  margin-bottom: 15px;
  cursor: pointer;
}

::v-deep .el-descriptions-item__cell {
  font-size: 14px;
  color: #000000;
  font-weight: 600 !important;

  div {
    font-size: 14px;
    color: #000000;
    font-weight: 400 !important;
  }
}
</style>
